import React, { useEffect } from 'react';
import cn from 'classnames';
import { useLocation } from 'react-router-dom';

import Sidebar from '../Sidebar';
import Footer from '../Footer';
import Notification from '../../common/ui/Notification';
import useWindowSize from '../../../hooks/useWindowSize';
import VerizonBanner from '../../common/features/VerizonBanner';

import styles from './styles.module.scss';

const Layout = ({ className, children }) => {
  const windowSize = useWindowSize();
  const isMobile = windowSize?.width < 768;
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className={styles.page}>
      <VerizonBanner />

      {isMobile && <Sidebar isMobile />}
      <div className={styles.content}>
        {!isMobile && <Sidebar />}
        <main className={cn(styles.main, className)}>{children}</main>
        <Notification />
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
